// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://admin.app.lumi.staging3.keetup.com/api/v1/',
  baseUrl: 'https://admin.app.lumi.staging3.keetup.com',
  paymentsUrl: 'http://fenix-payments.test/',
  apiKeyMap: 'AIzaSyCCbiPN9YjS7Y3TJgybXopyeJTCfuF9A4I',
  auth: {
    clientSecret: 'xGbAhWL960HycCoboFNvKdhpWJxnLdxIs55Gjn95',
    clientId: '2'
  },
  adminBaseUrl: 'http://admin.app.lumi.staging3.keetup.com/password/reset',
  videoIntro: '415581978'
  //videoIntro: '404642466'
  
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
